<template>
<div>
    <!-- <div class="hero-about bg-alt h-500"></div> -->
    
    <div class="py-md-3 py-lg-5 px-6">
        <div class="row">
            <div class="col-12 col-xl-10 offset-xl-1 pt-10">
                <div class="row">
                    <div class="col-12">
                        <h1 class="mb-4">Contact Home Solutions Design Group</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="d-flex flex-column col-12 col-lg-6 offset-xl-1 order-lg-2 flex-grow-2 pb-5 pb-md-0">
                        <div class="d-flex flex-grow-2 flex-column">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3252.6662195005674!2d149.16624731631603!3d-35.38873360696408!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b164bb75f314559%3A0x202919334e8b48d6!2sHome+solutions+architecture!5e0!3m2!1sen!2sau!4v1527139765473" width="100%" frameborder="0" style="border:0; display:flex; flex-grow: 2;" allowfullscreen></iframe>
                        </div>
                            <div class="d-flex align-self-flex-end pt-3 justify-content-between flex-wrap">
                                <div class="col-12 mb-2 mb-sm-0 mb-4 col-sm-4 p-0 d-flex flex-column">
                                    <h5>Office</h5>
                                    <span class="contact-detail">46 Sheppard St, Hume ACT 2620</span>
                                </div>
                                <div class="col-12 mb-2 mb-sm-0 mb-4 col-sm-4 p-0 d-flex flex-column align-items-md-center">
                                    <div>
                                        <h5>Phone</h5>
                                        <a href="tel:0262601042" class="contact-detail">(02) 6260 1042</a>
                                    </div>
                                </div>
                                <div class="col-12 mb-2 mb-sm-0 col-sm-4 p-0 d-flex flex-column align-items-md-end">
                                    <div>
                                        <h5>Email</h5>
                                        <a href="mailto:info@hsol.com.au" class="contact-detail">info@hsol.com.au</a>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="col-12 col-lg-6 col-xl-5 order-lg-1">
                        <p>Let us show you what is possible.</p>
                        <p>Phone now for a no-obligation meeting, or complete your contact details below and we will get back to you</p>
                        <div class="col-12 col-xl-9 p-0">
                            <talk-with-us></talk-with-us>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import TalkWithUs from './home/TalkWithUs'

export default {
	name: 'contact',
	data() {
		return {
			assets: process.env.ASSETS_URL
		}
	},
	components: {
		TalkWithUs
	},
	head: {
		title: {
			inner:
				'Contact Home Solutions Design Group | Canberra 3D Drafting | Canberra House Plans'
		},
		// Meta tags
		meta: [
			{
				name: 'description',
				content:
					'Get in touch with the friendly team at Home Solutions Architure',
				id: 'desc'
			}
		]
	}
}
</script>

<style>
.flex-grow-2 {
	flex-grow: 2;
}
.contact-detail {
	font-size: 1.05rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue